/**
 * Type stubs for @tracksuit/frontend/schemas
 *
 * Zod schemas and types used by the frontend.
 * Replace with actual schemas from the package when available.
 */
import { z } from "zod";

export const date = z.string();
export const naturalNumber = z.number().int().nonnegative();

export const questionType = z.enum([
  "UNPROMPTED_AWARENESS",
  "PROMPTED_AWARENESS",
  "CONSIDERATION",
  "INVESTIGATION",
  "USAGE",
  "PREFERENCE",
  "QUALIFYING",
]);
export type QuestionType = z.infer<typeof questionType>;

export type FunnelQuestionType = QuestionType;

export const timelineConversionIds = z.enum([
  "PROMPTED_AWARENESS-CONSIDERATION",
  "CONSIDERATION-PREFERENCE",
]);
export type TimelineConversionIds = z.infer<typeof timelineConversionIds>;

export const conversionQuestionType = questionType.exclude([
  "QUALIFYING",
]);
export type ConversionQuestionType = z.infer<typeof conversionQuestionType>;

export const dateComparisonPeriod = z.enum(["preceding", "year-on-year"]);
export type DateComparisonPeriod = z.infer<typeof dateComparisonPeriod>;

export const dataRepresentation = z.enum(["percentage", "absolute"]);
export type DataRepresentation = z.infer<typeof dataRepresentation>;

export type SampleQuality = "SUFFICIENT" | "INDICATIVE" | "INSUFFICIENT";

export type ExportFormat = "pptx" | "pdf" | "csv";

export type CustomQuestionType =
  | "SUB_CATEGORY"
  | "CATEGORY_PURCHASE_FREQUENCY"
  | "PLACE_OF_PURCHASE_RETAILERS"
  | "PLACE_OF_PURCHASE_CHANNELS"
  | "PLACE_OF_PURCHASE_ONLINE_OFFLINE"
  | "DEMOGRAPHICS_MULTIPLE_RESPONSE"
  | "DEMOGRAPHICS_SINGLE_RESPONSE"
  | "NPS"
  | "BRAND_ACTIVITY_RECALL"
  | "SOURCES_OF_AWARENESS"
  | "DEMOGRAPHICS_SEGMENTATION"
  | "DEMOGRAPHICS_EDUCATION"
  | "DEMOGRAPHICS_EMPLOYMENT"
  | "DEMOGRAPHICS_HOBBIES_INTEREST"
  | "DEMOGRAPHICS_HOME_OWNERSHIP"
  | "DEMOGRAPHICS_SPORTS_INTEREST"
  | "CUSTOM_QUESTION";

export enum Demographic {
  AGE = 10000,
  GENDER = 10011,
  INCOME = 10007,
  ETHNICITY = 10008,
  REGION_NZ = 10010,
  REGION_AU = 10013,
  REGION_US = 10020,
  REGION_UK = 10021,
  REGION_CA = 10022,
  REGION_DE = 10024,
  REGION_FR = 10031,
  REGION_ES = 10032,
  REGION_IT = 10033,
  PERSONAS = 10017,
  HOUSEHOLD_STATUS = 10002,
  PARENTAL_STATUS = 10003,
  EMPLOYMENT = 10004,
  EDUCATION = 10006,
}

export type DemographicMetric = {
  value: number;
  color: string;
  labelColor?: string;
  className?: string;
  showLabel?: boolean;
};

export type DemographicFilter = {
  filterTypeId: number;
  label: string;
  filters?: string[];
  difference: {
    value: number;
    significant: boolean;
  };
  metrics: DemographicMetric[];
};

export type DemographicLegend = {
  label?: string;
  color?: string;
};
